/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PremiumDueInsuredOptionDto
 */
export interface PremiumDueInsuredOptionDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumDueInsuredOptionDto
     */
    insuredId: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueInsuredOptionDto
     */
    name: string;
}

/**
 * Check if a given object implements the PremiumDueInsuredOptionDto interface.
 */
export function instanceOfPremiumDueInsuredOptionDto(value: object): value is PremiumDueInsuredOptionDto {
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PremiumDueInsuredOptionDtoFromJSON(json: any): PremiumDueInsuredOptionDto {
    return PremiumDueInsuredOptionDtoFromJSONTyped(json, false);
}

export function PremiumDueInsuredOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumDueInsuredOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredId': json['insuredId'],
        'name': json['name'],
    };
}

export function PremiumDueInsuredOptionDtoToJSON(json: any): PremiumDueInsuredOptionDto {
    return PremiumDueInsuredOptionDtoToJSONTyped(json, false);
}

export function PremiumDueInsuredOptionDtoToJSONTyped(value?: PremiumDueInsuredOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredId': value['insuredId'],
        'name': value['name'],
    };
}

